var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5918 9.40833L11.4252 5.24166C11.3459 5.16579 11.2524 5.10632 11.1502 5.06666C10.9473 4.98331 10.7197 4.98331 10.5168 5.06666C10.4145 5.10632 10.3211 5.16579 10.2418 5.24166L6.07515 9.40833C5.99746 9.48603 5.93582 9.57827 5.89377 9.67979C5.85172 9.78131 5.83008 9.89011 5.83008 10C5.83008 10.2219 5.91823 10.4347 6.07515 10.5917C6.23207 10.7486 6.4449 10.8367 6.66682 10.8367C6.88874 10.8367 7.10157 10.7486 7.25849 10.5917L10.0002 7.84166V14.1667C10.0002 14.3877 10.088 14.5996 10.2442 14.7559C10.4005 14.9122 10.6125 15 10.8335 15C11.0545 15 11.2665 14.9122 11.4227 14.7559C11.579 14.5996 11.6668 14.3877 11.6668 14.1667V7.84166L14.4085 10.5917C14.486 10.6698 14.5781 10.7318 14.6797 10.7741C14.7812 10.8164 14.8901 10.8382 15.0002 10.8382C15.1102 10.8382 15.2191 10.8164 15.3206 10.7741C15.4222 10.7318 15.5144 10.6698 15.5918 10.5917C15.6699 10.5142 15.7319 10.422 15.7742 10.3205C15.8165 10.2189 15.8383 10.11 15.8383 10C15.8383 9.88999 15.8165 9.78106 15.7742 9.67951C15.7319 9.57796 15.6699 9.4858 15.5918 9.40833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/up arrow.8a52de6b0e5a1cbf509df3e9a19f36f9.svg";
export { ForwardRef as ReactComponent };